import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  TimeTrackingServiceCreateResponseJson,
  TimeTrackingServiceListRequestJson,
} from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedTimeTrackingActions = createActionGroup({
  source: 'PaginatedTimeTracking',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedTimeTrackings': props<{
      params: TimeTrackingServiceListRequestJson;
    }>(),
    'List PaginatedTimeTrackings Success': props<{
      data: ApiPaginated<TimeTrackingServiceCreateResponseJson>;
    }>(),
    'List PaginatedTimeTrackings Failure': props<{ error: unknown }>(),
  },
});
